module.exports = __webpack_public_path__ + "static/media/12.3df853f9.png";